import React from 'react'

const Error = () => {
  return (
    <div className='flex flex-1 justify-center items-center text-white text-3xl'>
        Error - 404 Not found
    </div>
  )
}

export default Error

